/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiActiveCustomersTrendPointFromJSON(json) {
    return ApiActiveCustomersTrendPointFromJSONTyped(json, false);
}
export function ApiActiveCustomersTrendPointFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'count': !exists(json, 'count') ? undefined : json['count'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
    };
}
export function ApiActiveCustomersTrendPointToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'count': value.count,
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
    };
}
